import ChargersView from '@/views/ChargersView.vue'
import ChargerView from '@/views/ChargerView.vue'
import ChargerOverviewView from '@/views/ChargerOverviewView.vue'
import ChargerUsersView from '@/views/ChargerUsersView.vue'
import ChargerSessionsView from '@/views/ChargerSessionsView.vue'
import ChargerSettingsView from '@/views/ChargerSettingsView.vue'
import type { RouteRecordRaw } from 'vue-router'
import ROUTES from './routes'

export default [
  {
    path: '',
    redirect: { name: ROUTES.CHARGERS }
  },
  {
    path: 'chargers',
    name: ROUTES.CHARGERS,
    component: ChargersView,
    props: true,
    meta: {
      resetBreadcrumb: true,
      breadcrumb: {
        name: ROUTES.CHARGERS,
        text: 'mywb.common.chargers'
      }
    }
  },
  {
    path: 'chargers/:chargerUid',
    component: ChargerView,
    props: true,
    meta: {
      breadcrumb: {
        name: ROUTES.CHARGER
      }
    },
    children: [
      {
        path: '',
        name: ROUTES.CHARGER,
        component: ChargerOverviewView
      },
      {
        path: 'users',
        name: ROUTES.CHARGER_DETAIL_USERS,
        component: ChargerUsersView
      },
      {
        path: 'sessions',
        name: ROUTES.CHARGER_DETAIL_SESSIONS,
        component: ChargerSessionsView
      },
      {
        path: 'settings',
        name: ROUTES.CHARGER_DETAIL_SETTINGS,
        component: ChargerSettingsView
      }
    ]
  }
] as RouteRecordRaw[]
